import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router-dom'
import { Alert } from 'shared/ui'
import {
  GOOGLE_CONNECTION_EXPIRED_ALERT,
  LIVE_DOCUMENTS_UNAVAILABLE_ALERT,
  useLiveDocumentsAccessLost,
} from 'entities/KnowledgeBase'
import { KnowledgeBaseRoutes } from 'pages/settings/pages/knowledgeBase'

type LiveDocumentAccessLostAlertProps = {
  hasGoogleSheetLiveDocument?: boolean
  hasGoogleDocLiveDocument?: boolean
  hasAccessLostDocument: boolean
}

export const LiveDocumentAccessLostAlert = observer(
  ({
    hasGoogleSheetLiveDocument = false,
    hasGoogleDocLiveDocument = false,
    hasAccessLostDocument,
  }: LiveDocumentAccessLostAlertProps) => {
    const navigate = useNavigate()
    const { isGoogleConnectionExpired, isLiveDocumentsUnavailable, reconnectGoogle } =
      useLiveDocumentsAccessLost({
        hasGoogleSheetLiveDocument,
        hasGoogleDocLiveDocument,
        hasAccessLostDocument,
      })

    if (isGoogleConnectionExpired) {
      return (
        <Alert
          item={{
            type: 'warning',
            desc: GOOGLE_CONNECTION_EXPIRED_ALERT,
          }}
          rightActions={[
            {
              variant: 'button',
              type: 'primary',
              text: 'Reconnect',
              onClick: reconnectGoogle,
            },
          ]}
        />
      )
    }

    if (isLiveDocumentsUnavailable) {
      return (
        <Alert
          item={{
            type: 'warning',
            desc: LIVE_DOCUMENTS_UNAVAILABLE_ALERT,
          }}
          rightActions={[
            {
              variant: 'button',
              type: 'primary',
              text: 'Knowledge Base',
              onClick: () => navigate(`/${KnowledgeBaseRoutes.root}`),
            },
          ]}
        />
      )
    }

    return null
  }
)
